import React from 'react';
import PropTypes from 'prop-types';
import { faDoNotEnter } from '@fortawesome/pro-solid-svg-icons/faDoNotEnter';

import BulkAction from './BulkAction';

const AddCharge = ({
  showModal,
  ...rest
}) => (
  <BulkAction
    icon={faDoNotEnter}
    title='Add Charge'
    onClick={() => showModal('BulkAddTransaction', {
      type: 'charge',
      ...rest
    })}
    {...rest}
  />
);

AddCharge.propTypes = {
  /** The contacts we wish to add a charge to */
  contacts: PropTypes.arrayOf(
    PropTypes.string
  ),

  /** Allows us to show a modal */
  showModal: PropTypes.func
};

AddCharge.defaultProps = {
  contacts: [],
  showModal: () => false
};

export default AddCharge;
